<ng-template #modalDeleteMultiple let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalDeleteMultipleForm()"
    (dismiss)="d()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'contacts_groups_multidelete_confirm' | translate }}"
  ></wsb-modal>
</ng-template>
<div class="page">
  <div class="page__container">
    <h1 *ngIf="page !== 'send' && page !== 'mail'" class="page__title h2 mb-5">{{ 'contact_groups' | translate }}</h1>
    <wsb-atlas-button *ngIf="page !== 'send' && page !== 'mail'" class="my-3" [label]="'contact_group_new'" (click)="openModalEdit()">{{
      'contact_group_new' | translate
    }}</wsb-atlas-button>
    <div class="my-5">
      <ng-template #modalEdit let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalEditForm()"
          cancelButtonEnable="true"
          [primaryDisabled]="editForm.invalid"
          (dismiss)="d()"
          title="{{ (contactGroupToEdit ? 'contacts_groups_edit_modal' : 'contact_group_new') | translate }}"
        >
          <div body>
            <form [formGroup]="editForm">
              <label for="group_name" translate>contacts_group_name</label>
              <input type="text" id="group_name" formControlName="name" name="group_name" class="form-control  form-control--short" />
              <wsb-validation-error-msg [fc]="editForm.get('name')"></wsb-validation-error-msg>
              <label for="group_description" translate>common_description</label>
              <textarea
                id="group_description"
                formControlName="description"
                name="group_description"
                class="form-control  form-control--short"
              ></textarea>
              <wsb-validation-error-msg [fc]="editForm.get('description')"></wsb-validation-error-msg>
            </form>
          </div>
        </wsb-modal>
      </ng-template>
      <ng-template #modalDelete let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}"
          text="{{ 'contacts_groups_delete_prompt' | translate }}"
        ></wsb-modal>
      </ng-template>

      <wsb-atlas-grid
        #grid
        class="atlas-grid-simplest"
        class="mt-2"
        *ngIf="tableColumnDefs && tableGridOptions"
        [loading]="tableLoading"
        [columnDefs]="tableColumnDefs"
        [checkboxDisable]="true"
        [options]="tableGridOptions"
        [@gridIsLoaded]="gridAnimationState"
        [components]="components"
      >
      </wsb-atlas-grid>
      <!--      [rowData]="tableData"-->
    </div>
  </div>
</div>
